export class DiagnosticBag {
    items = [];
    error(message, line, col, length = 1) {
        this.items.push({ severity: "error", message, line, col, length });
    }
    warning(message, line, col, length = 1) {
        this.items.push({ severity: "warning", message, line, col, length });
    }
    hasErrors() {
        return this.items.some((d) => d.severity === "error");
    }
}
export function formatDiagnostic(d) {
    const pos = `${String(d.line)}:${String(d.col)}`.padStart(6);
    return `${pos}  ${d.severity.padEnd(7)} ${d.message}`;
}
export function formatDiagnostics(items) {
    return items.map(formatDiagnostic).join("\n");
}
//# sourceMappingURL=diagnostics.js.map